import axios from ".";

export const sendMessage = async ({ text }: { text: string }) => {
  return axios.post(`/slack/send-message`, { text });
};
